
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { OnboardingData } from '../OnboardingFlow';

interface IntensityStepProps {
  data: OnboardingData;
  updateData: (data: Partial<OnboardingData>) => void;
  onNext: () => void;
  onBack: () => void;
}

const IntensityStep = ({ data, updateData, onNext, onBack }: IntensityStepProps) => {
  const [intensity, setIntensity] = useState<'light' | 'medium' | 'intense'>(data.intensity);

  const handleNext = () => {
    updateData({ intensity });
    onNext();
  };

  const intensityOptions = [
    { value: 'light', label: 'Light', description: 'Gentle reminders and easy goals' },
    { value: 'medium', label: 'Medium', description: 'Balanced approach with steady progress' },
    { value: 'intense', label: 'Intense', description: 'Challenging goals and strong accountability' }
  ];

  return (
    <div className="text-center space-y-8">
      <div>
        <h2 className="text-2xl font-semibold text-slate-dark mb-3 font-sans">
          How intense do you want your PACTs to be?
        </h2>
        <p className="text-sm text-slate-light font-sans">
          You can change this anytime in Settings.
        </p>
      </div>
      
      <div className="space-y-3">
        {intensityOptions.map((option) => (
          <button
            key={option.value}
            onClick={() => setIntensity(option.value as 'light' | 'medium' | 'intense')}
            className={`w-full p-4 rounded-xl border-2 transition-all duration-300 text-left ${
              intensity === option.value
                ? 'border-blue-primary bg-blue-whisper'
                : 'border-slate-soft hover:border-slate-light hover:bg-slate-whisper'
            }`}
          >
            <div className="font-semibold text-slate-dark font-sans">{option.label}</div>
            <div className="text-sm text-slate-light mt-1 font-sans">{option.description}</div>
          </button>
        ))}
      </div>
      
      <div className="space-y-3">
        <Button
          onClick={handleNext}
          className="w-full h-14 text-lg font-semibold bg-blue-primary hover:bg-blue-light text-white rounded-xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98]"
        >
          Next
        </Button>
        
        <Button
          onClick={onBack}
          variant="ghost"
          className="w-full h-12 text-slate-medium hover:text-slate-dark hover:bg-slate-whisper rounded-xl transition-all duration-300 font-sans"
        >
          Back
        </Button>
      </div>
    </div>
  );
};

export default IntensityStep;
